<template>
  <div class="container">
    <div v-if="list && list.length">
      <div class="search-box">
        <van-search
          v-model="searchText"
          placeholder="搜索医生"
          @search="toSearch"
          @clear="toSearch"
        />
      </div>
      <div class="doctor-list">
        <div
          class="doctor-item"
          @click="toDoctorDetail(item.doctorCode)"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="doctor-box">
            <div class="card-item">
              <div class="head-box">
                <img src="@/assets/head.jpg" alt="头像" />
              </div>
              <div class="head-name-detail">
                <div class="detail-item">
                  <span class="name">{{ item.doctorName }}</span>
                </div>
                <div class="detail-item">{{ item.doctorTitle }}</div>
              </div>
              <div class="follow-enabled"><van-icon name="star" />已关注</div>
              <!-- <div class="follow-disabled" v-if="item.mark!=1">
              <van-icon name="star-o" />关注
            </div> -->
            </div>
            <div class="footer">擅长：{{ item.genius }}</div>
          </div>
        </div>
      </div>
    </div>
    <van-empty
      v-else
      class="custom-image"
      image="https://img.yzcdn.cn/vant/custom-empty-image.png"
      description="暂无关注的医生"
    />
  </div>
</template>

<script>
import { getFollow } from '@/api/api'
export default {
  data() {
    return {
      searchText: '',
      list: []
    }
  },
  created() {},
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      getFollow(this.searchText).then(res => {
        if (res.data && res.data.length) {
          // res.data.forEach(element => {
          //   element.mark = 1
          // });
          this.list = res.data
        } else {
          this.list = []
        }
      })
    },
    toSearch() {
      this.getList()
    },
    toDoctorDetail(id) {
      this.$router.push({
        name: 'doctorDetail',
        query: {
          docCode: id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  height: 100vh;
  background: #fff;
}
.search-box {
  width: 100vw;
  height: 54px;
  border-bottom: 1px solid #ebedf0;
}

.doctor-list {
  height: calc(100vh - 54px);
  max-height: calc(100vh - 54px);
  overflow-y: auto;
  width: 100vw;
  padding: 10px;
  .doctor-item {
    width: 100%;
    background: #fff;
    box-shadow: 0 0 5px rgb(195, 195, 195);
    padding: 10px;
    font-size: 13px;
    margin-bottom: 10px;
    .doctor-box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      .card-item {
        width: 100%;
        padding: 10px 10px;
        display: flex;
        align-items: center;
        position: relative;
        border-bottom: 1px rgb(195, 195, 195) dashed;
        .follow-enabled {
          position: absolute;
          right: 0;
          top: 0;
          font-size: 13px;
          width: 65px;
          height: 20px;
          color: rgb(8, 112, 253);
          background: rgb(240, 240, 240);
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 10px;
        }
        .follow-disabled {
          position: absolute;
          right: 0;
          top: 0;
          font-size: 13px;
          width: 65px;
          height: 20px;
          color: rgb(8, 112, 253);
          background: rgb(240, 240, 240);
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 10px;
        }
        .head-box {
          width: 40px;
          height: 40px;
          img {
            width: 40px;
            height: 40px;
            border-radius: 20px;
          }
        }
        .head-name-detail {
          width: calc(100% - 50px);

          .detail-item {
            width: 100%;
            height: 22.5px;
            display: flex;
            align-items: flex-end;
            padding-left: 10px;
            color: #666;
            font-size: 12px;
            .name {
              font-size: 15px;
              padding-right: 10px;
              color: #000;
            }
            .status {
              padding: 2px 5px;
              color: #fff;
              border-radius: 3px;
              margin-left: 10px;
            }
            .color-blue {
              background: #3478f7;
            }
            .color-red {
              background: red;
            }
          }
        }
      }
      .footer {
        width: 100%;
        font-size: 13px;
        color: #666;
        padding: 5px;
      }
    }
    .doctor-num {
      width: 100%;
      height: 28px;
      display: flex;
      align-items: center;
      padding-left: 10px;
      justify-content: space-between;
      .bet {
        .much {
          font-size: 12px;
          color: rgb(237, 125, 84);
          padding-right: 5px;
        }
      }
    }
  }
}
</style>
